import { LITE_TRADE_POSITION_SIDE } from "../../LiteTrade/liteTradeConstants";

export const BEGINNERS_GUIDE_STEPS_COUNT = 6;

export const BEGINNERS_GUIDE_SIDE_PRICES = {
    [LITE_TRADE_POSITION_SIDE.BUY]: 100.58,
    [LITE_TRADE_POSITION_SIDE.SELL]: 100.27,
} as const;

export const BEGINNERS_GUIDE_ASSET_SYMBOL = 'BTCUSD';

export const BEGINNERS_GUIDE_POSITION_MARGIN_USD = 10;
export const BEGINNERS_GUIDE_BALANCE_AMOUNT_USD = 100;

export const BEGINNERS_GUIDE_POSITION_PL_AMOUNTS = [
    -3.12,
    0,
    5.49,
] as const;
